import { useEffect, useMemo, useState } from 'react';
import { ImportableProperties } from 'models/bookingDotCom/ImportableProperties';
import useBookingDotComOperationsImportImportablePropertiesMutation from '../useBookingDotComOperationsImportImportablePropertiesMutation';
import ImportBookingDotComPropertiesContext from './ImportBookingDotComPropertiesContext';
import { CONNECTION_STEP } from './ImportBookingDotComPropertiesModal.utils';

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const ImportBookingDotComPropertiesContextProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<CONNECTION_STEP>(
    CONNECTION_STEP.CONNECT_TO_PROVIDER,
  );
  const [importableProperties, setImportableProperties] = useState<
    ImportableProperties[]
  >([]);
  const [isImportablePropertiesLoading, setIsImportablePropertiesLoading] =
    useState<boolean>(false);

  const { getImportableProperties } =
    useBookingDotComOperationsImportImportablePropertiesMutation();

  useEffect(() => {
    setIsImportablePropertiesLoading(true);
    getImportableProperties({
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      successCallback: (_importableProperties) => {
        setImportableProperties(_importableProperties);
        setIsImportablePropertiesLoading(false);
        if (_importableProperties?.length > 0) {
          setCurrentStep(CONNECTION_STEP.PROPERTY_SELECTION);
        }
      },
    });
  }, []);

  const contextValue = useMemo(
    () => ({
      currentStep,
      setCurrentStep,
      importableProperties,
      setImportableProperties,
      isImportablePropertiesLoading,
      setIsImportablePropertiesLoading,
    }),
    [currentStep, importableProperties, isImportablePropertiesLoading],
  );

  return (
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <ImportBookingDotComPropertiesContext.Provider value={contextValue}>
      {children}
    </ImportBookingDotComPropertiesContext.Provider>
  );
};

export default ImportBookingDotComPropertiesContextProvider;
